const confirmActions = {
  
  DO_CONFIRM_EMAIL: 'DO_CONFIRM_EMAIL',
  DO_CONFIRM_EMAIL_SUCCEEDED: 'DO_CONFIRM_EMAIL_SUCCEEDED',
  DO_CONFIRM_EMAIL_FAILED: 'DO_CONFIRM_EMAIL_FAILED',
  doConfirmEmail: hash => ({
    type: confirmActions.DO_CONFIRM_EMAIL,
    payload: hash,
  }),
  doConfirmEmailSucceeded: response => ({
    type: confirmActions.DO_CONFIRM_EMAIL_SUCCEEDED,
    payload: response,
  }),
  doConfirmEmailFailed: response => ({
    type: confirmActions.DO_CONFIRM_EMAIL_FAILED,
    payload: response,
  }),
}

export default confirmActions;


// WEBPACK FOOTER //
// ./src/redux/confirm/actions.js